import { Sector } from '@/domain/impact/impact.entity';
import {
  Category,
  Co2Section,
} from '@/domain/impact-co2/entities/question.entity';
import { Co2QuizFormData } from '@/ui/pages/app/components/quiz-panel/co2/Co2QuizFormData';

import { getFieldsByCategory } from '../utils/fields';
import {
  getCategoryTranslate,
  getCo2SectionTranslate,
  getSectorTranslate,
} from '../utils/translate';

export function preparaDataToForExcelExport(
  co2FormsData: Co2QuizFormData[],
): Co2QuestionsDataStructure {
  return co2FormsData.map((form) => ({
    sectorKey: form.sector,
    sectorLabel: getSectorTranslate(form.sector),
    sections: form.sections.map((section) => ({
      sectionKey: section.sectionKey,
      sectionLabel: getCo2SectionTranslate(section.sectionKey),
      questions: section.questions.map((question) => ({
        key: question,
        label: getCategoryTranslate(question),
        fields: getFieldsByCategory(question),
      })),
    })),
  }));
}

export type Co2QuestionsDataStructure = {
  sectorKey: Sector;
  sectorLabel: string;
  sections: {
    sectionKey: Co2Section;
    sectionLabel: string;
    questions: Question[];
  }[];
}[];

export type Question = {
  key: Category;
  label: string;
  fields: {
    key: string;
    label: string;
    type: string;
    values: string;
  }[];
};
